import {useNavigation} from '@react-navigation/native';
import React, {useState} from 'react';
import {
  ActivityIndicator,
  Alert,
  Image,
  ImageBackground,
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import ButtonComponent from '../../../components/ButtonComponent/ButtonComponent';
import Input from '../../../components/Input/Input';
import {Images} from '../../../constants/Images';
import {styles} from './styles';
import FontAwesome6 from 'react-native-vector-icons/FontAwesome6';
import {Colors} from '../../../constants/Colors';
import AuthService from '../../../services/AuthService/AuthService';
import {NavigationProps} from '../../../navigation/Routes';
import {AppRoutes} from '../../../navigation/Routes.types';
import {useLoadingStore} from '../../../store/LoadingStore';

const RecoverPassword = () => {
  const {navigate, goBack} = useNavigation<NavigationProps>();
  const [loading, setLoading] = useState<boolean>(false);
  const {hideLoading, showLoading} = useLoadingStore();

  const [document, setDocument] = useState<string>('');

  const handleNavigateRecover = async () => {
    if (document) {
      showLoading();
      try {
        await AuthService.recoverPasswordPost(document);
        navigate(AppRoutes.RESET_TOKEN, {user: document});
      } catch (error: any) {
        Alert.alert('Opss...', 'Algo deu errado. Tente novamente.');
      } finally {
        hideLoading();
      }
    } else {
      Alert.alert('Informe seu CNPJ/CPF para prosseguir');
    }
  };

  return (
    <ImageBackground style={styles.imageBackground}>
      <KeyboardAvoidingView
        behavior={Platform.OS === 'ios' ? 'position' : 'height'}
        style={styles.container}>
        <ScrollView showsVerticalScrollIndicator={false}>
          <View style={styles.containerArrow}>
            <TouchableOpacity onPress={goBack} style={styles.arrowButton}>
              <FontAwesome6
                name="arrow-left"
                color={Colors.GrayPallete.lightgrayThree}
                size={22}
              />
            </TouchableOpacity>
            <Image source={Images.ProfileSimbol} style={styles.simbol} />
          </View>
          <Text style={styles.recover}>Recuperar senha</Text>
          <Text style={styles.description}>
            Digite seu CNPJ/CPF e enviaremos um código de 6 dígitos pelos seus
            canais de contato cadastrados para você redefinir a senha. O código é válido por 30 minutos.
          </Text>
          <Input
            title="CNPJ/CPF"
            placeholder="CNPJ/CPF"
            keyboardType="default"
            mt={30}
            onChangeText={text => setDocument(text)}
          />
          <View style={styles.containerButton}>
            {loading ? (
              <ActivityIndicator color={Colors.RedPallete.red} size={20} />
            ) : (
              <ButtonComponent
                title="Enviar código"
                onPress={handleNavigateRecover}
              />
            )}
          </View>
          <View style={styles.containerBack}>
            <TouchableOpacity onPress={goBack}>
              <Text style={styles.goBack}>Volte ao login.</Text>
            </TouchableOpacity>
          </View>
        </ScrollView>
      </KeyboardAvoidingView>
    </ImageBackground>
  );
};

export default RecoverPassword;
